import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import CarouselArrow from "./CarouselArrow";
import Item from "./Item";

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  cssEase: "linear",
  lazyLoad: true,

  autoplaySpeed: 5000,
  nextArrow: <CarouselArrow direction="next" />,
  prevArrow: <CarouselArrow direction="prev" />,
  responsive: [
    {
      breakpoint: 960,
      settings: {
        dots: false,
        height: "0px",
      },
    },
  ],
};

const Carousel = ({ carouselData }) => {
  return (
    <div id="home-banner-carousel">
      <Slider autoplay {...settings}>
        {carouselData.map((banner) => {
          return <Item {...banner} />;
        })}
      </Slider>
    </div>
  );
};

export default Carousel;
